import React from 'react';

const SkeletonBlock: React.FC<{ className?: string }> = ({
  className = '',
}) => <span className={`homepage-skeleton-block ${className}`.trim()} />;

export const LibraryMetricValueSkeleton: React.FC = () => (
  <SkeletonBlock className="library-metric-value-skeleton" />
);

export const SeedSearchFieldSkeleton: React.FC = () => (
  <div
    className="seed-search-field seed-search-field-skeleton"
    aria-hidden="true"
  >
    <SkeletonBlock className="seed-search-field-skeleton-thumb" />
    <span className="seed-search-field-skeleton-copy">
      <SkeletonBlock className="seed-search-field-skeleton-title" />
      <SkeletonBlock className="seed-search-field-skeleton-artist" />
    </span>
    <SkeletonBlock className="seed-search-field-skeleton-meta" />
  </div>
);

export const WidgetTabPillsSkeleton: React.FC = () => (
  <div className="crate-tabs widget-tab-pills-skeleton" aria-hidden="true">
    <SkeletonBlock className="widget-tab-pill-skeleton" />
    <SkeletonBlock className="widget-tab-pill-skeleton widget-tab-pill-skeleton--short" />
  </div>
);

export const WidgetListRowSkeleton: React.FC = () => (
  <div className="widget-list-row-skeleton" aria-hidden="true">
    <SkeletonBlock className="widget-list-row-skeleton-thumb" />
    <span className="widget-list-row-skeleton-copy">
      <SkeletonBlock className="widget-list-row-skeleton-title" />
      <SkeletonBlock className="widget-list-row-skeleton-subtitle" />
    </span>
    <span className="widget-list-row-skeleton-meta">
      <SkeletonBlock className="widget-list-row-skeleton-meta-line" />
      <SkeletonBlock className="widget-list-row-skeleton-meta-line widget-list-row-skeleton-meta-line--short" />
    </span>
  </div>
);

export const WidgetListRowsSkeleton: React.FC<{ count?: number }> = ({
  count = 4,
}) => (
  <div className="widget-list-rows-skeleton">
    {Array.from({ length: count }).map((_, index) => (
      <WidgetListRowSkeleton key={index} />
    ))}
  </div>
);

export const AnnouncementFeedSkeleton: React.FC<{ count?: number }> = ({
  count = 3,
}) => (
  <div className="announcement-feed-skeleton" aria-hidden="true">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="announcement-card-skeleton">
        <SkeletonBlock className="announcement-card-skeleton-media" />
        <SkeletonBlock className="announcement-card-skeleton-date" />
        <SkeletonBlock className="announcement-card-skeleton-title" />
      </div>
    ))}
  </div>
);
